import {trackEvent} from '@hconnect/common/logging/Analytics'
import {QueryFunction, useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {api} from '../../../../../App.store'
import {SlotManagementConfig} from '../types/SlotManagementConfig'

import {SlotManagementConfigQueryKey, ProductConfigsQueryKey} from './queryKeys'

const slotManagementConfigurationFetcher: QueryFunction<SlotManagementConfig[]> = async () => {
  const response = await api.get<SlotManagementConfig[]>('/product-configs/slot-management-settings')
  return response.data
}

export const useSlotManagementConfigsQuery = () => {
  return useQuery<SlotManagementConfig[], AxiosError>(
    [ProductConfigsQueryKey, SlotManagementConfigQueryKey],
    slotManagementConfigurationFetcher,
    {
      onError: (error) => {
        console.error(error)
        trackEvent('adminConsoleError', {
          product: 'adminConsole',
          date: new Date().toISOString(),
          errorCode: error.response?.status,
          component: 'useSlotManagementConfigsQuery',
          endpoint: '/product-configs/slot-management-settings'
        })
      }
    }
  )
}
